import {
  Box,
  Typography,
  Button,
  Divider,
  Container,
  Link,
  Card,
  CardActionArea,
  CardContent,
  Link as MUILink,
  Paper,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ReactPlayer from "react-player";
import { useState, useRef } from "react";

// export const HeroImage = () => {
//   return (
//     <>
//       <Box
//         sx={{
//           height: { xs: "180px", md: "250px" },
//           width: "100%",
//           backgroundImage: "url('/Resources3.png')",
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//         }}
//       />
//       <Box sx={{ width: "100%", height: "20px", backgroundColor: "#1B2E85" }} />
//     </>
//   );
// };

// export const HeroContentBox: React.FC = () => {
//   return (
//     <Box
//       sx={{
//         backgroundColor: "#F5F5F5",
//         maxWidth: "560px",
//         marginTop: "-75px",
//         position: "relative",
//         padding: { xs: 3, md: 4 },
//         mx: "auto",
//         textAlign: "center",
//       }}
//     >
//       {/* Heading */}
//       <Typography
//         variant="h2"
//         fontWeight="bold"
//         textAlign="center"
//         color="#1B2E85"
//         sx={{ mb: 2 }}
//       >
//         Resources
//       </Typography>

//       {/* Divider */}
//       <Divider
//         sx={{
//           width: "60px",
//           height: "4px",
//           backgroundColor: "#1B2E85",
//           mx: "auto",
//           mb: 2,
//         }}
//       />

//       {/* Body Text */}
//       <Typography variant="h6" color="text.secondary">
// Browse videos, our graph database, research papers, and more to explore
// how AI and clinical expertise are shaping the future of hereditary
// cancer care.
//       </Typography>
//     </Box>
//   );
// };

export function VideosSection() {
  return (
    <Box
      sx={{
        backgroundColor: "#1B2E85",
        mt: { xs: 6, md: 8 },
        px: { xs: 3, md: 6 },
        py: { xs: 6, md: 10 },
        color: "white",
      }}
    >
      <Typography
        variant="h3"
        fontWeight="bold"
        textAlign="center"
        sx={{ mb: 2 }}
      >
        Videos
      </Typography>

      <Box
        sx={{
          width: "60px",
          height: "3px",
          backgroundColor: "white",
          margin: "0 auto",
          mb: 6,
        }}
      />

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          justifyContent: "center",
          gap: { xs: 4, md: 6 },
        }}
      >
        {/* Text + Line */}
        <Box
          sx={{
            display: "flex",
            alignItems: "stretch",
            maxWidth: 500,
            textAlign: "left",
          }}
        >
          {/* Vertical Line */}
          <Box
            sx={{
              width: "15px",
              bgcolor: "white",
              borderRadius: 1,
              mr: 2,
              display: { xs: "none", md: "block" },
            }}
          />

          {/* Text Block */}
          <Box>
            <Typography variant="h4" fontWeight="bold" sx={{ mb: 1 }}>
              AI in Healthcare
            </Typography>
            <Typography variant="h6" fontWeight="medium" lineHeight={1.6}>
              Dr. Kevin Hughes, a breast surgeon at MUSC, shares how AI can
              streamline tasks in breast surgery, healthcare, and beyond. He
              also discusses how AI models are trained, the challenges of
              adoption in medicine, and why AI is key to the future of
              healthcare.
            </Typography>
          </Box>
        </Box>

        {/* Video */}
        <Box
          sx={{
            width: "100%",
            maxWidth: 640,
            aspectRatio: "16 / 9",
            backgroundColor: "black",
            flexShrink: 0,
          }}
        >
          <ReactPlayer
            src="https://www.dropbox.com/scl/fi/h1j02u0nxz8hmp83kqq1c/Template_Hughes_ASBrS-Utilization-of-AI-60Minutes-Fellows2025_Video.mp4?rlkey=irh8kntykva3s4g2qezr3fk8h&raw=1"
            controls
            width="100%"
            height="100%"
          />
        </Box>
      </Box>
    </Box>
  );
}

export function GraphHeroSection() {
  return (
    <Box
      sx={{
        bgcolor: "#f9fafc",
        py: { xs: 8, md: 12 },
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            px: 2,
          }}
        >
          {/* Text Content */}
          <Typography
            variant="h3"
            fontWeight="bold"
            color="#1B2E85"
            sx={{ mb: 2 }}
          >
            Gene ↔ Cancer Connections
          </Typography>

          <Typography
            variant="h6"
            color="text.secondary"
            sx={{ mb: 3, maxWidth: 600 }}
          >
            Explore how hereditary cancer syndromes link genes and organs
            through intelligent graph visualization. Our interactive tool helps
            surface insights across conditions, genes, and cancer types.
          </Typography>

          {/* Image on Top */}
          <Box
            component="img"
            src="/graphdb2.png"
            alt="Graph Visualization"
            sx={{
              width: "100%",
              maxWidth: 650,
              borderRadius: 2,
              boxShadow: 3,
              mb: 4,
            }}
          />

          <Button
            component="a"
            href="https://graph.hereditarycancer.ai/"
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            sx={{
              backgroundColor: "#1B2E85",
              color: "#ffffff",
              fontWeight: "bold",
              "&:hover": {
                backgroundColor: "#16246d",
              },
            }}
          >
            Visit the Graph
          </Button>
        </Box>
      </Container>
    </Box>
  );
}

// --- TYPES ---
type ResourceItem = {
  label: string;
  href: string;
};

type ResourceSectionData = {
  title: string;
  bgColor: string;
  items: ResourceItem[];
};

// --- DATA ---
const resourceSections: ResourceSectionData[] = [
  {
    title: "Papers",
    bgColor: "#F5F5F5",
    items: [
      {
        label:
          "Implementation Mapping for Managing Patients at High Risk for Hereditary Cancer",
        href: "/AllenHughesPaper.pdf",
      },
      {
        label: "Coming soon...",
        href: "#",
      },
    ],
  },
  {
    title: "PowerPoints",
    bgColor: "#F5F5F5",
    items: [
      {
        label: "Coming soon...",
        href: "#",
      },
    ],
  },
];

// --- SECTION COMPONENT ---
function ResourceSection({ title, bgColor, items }: ResourceSectionData) {
  return (
    <Paper
      elevation={3}
      sx={{
        flex: "1 1 calc(50% - 2rem)",
        minWidth: "350px",
        maxWidth: "400px",
        minHeight: "240px",
        p: { xs: 4, md: 5 },
        background: bgColor,
        borderRadius: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Typography variant="h5" fontWeight="bold" color="#1B2E85" mb={1}>
        {title}
      </Typography>

      <Box
        sx={{
          width: "60px",
          height: "3px",
          backgroundColor: "#1B2E85",
          mb: 2,
        }}
      />

      {items.map((item, index) => (
        <Link
          key={index}
          href={item.href}
          target="_blank"
          rel="noopener"
          underline="hover"
          sx={{ mt: index === 0 ? 0 : 1 }}
        >
          {item.label}
        </Link>
      ))}
    </Paper>
  );
}

// --- WRAPPED BLOCK ---
export function PaperAndPowerpointResources() {
  return (
    <Paper
      elevation={1}
      sx={{
        backgroundColor: "white",
        px: { xs: 3, md: 6 },
        py: { xs: 5, md: 8 },
        borderRadius: 0,
      }}
    >
      {/* Title + Divider */}
      <Box sx={{ textAlign: "center", mb: 6 }}>
        <Typography
          variant="h3"
          fontWeight="bold"
          color="#1B2E85"
          sx={{ mb: 1 }}
        >
          Additional Resources
        </Typography>

        <Divider
          sx={{
            width: "60px",
            height: "4px",
            backgroundColor: "#1B2E85",
            margin: "0 auto",
          }}
        />
      </Box>

      {/* Section Cards */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: 4,
        }}
      >
        {resourceSections.map((section, index) => (
          <ResourceSection
            key={index}
            title={section.title}
            bgColor={section.bgColor}
            items={section.items}
          />
        ))}
      </Box>
    </Paper>
  );
}

// --- PODCAST DATA ---
export type PodcastItem = {
  title: string;
  href: string;
  img: string;
  alt?: string;
};

export const AI_PODCASTS: PodcastItem[] = [
  {
    title: "This Day in AI Podcast",
    href: "https://podcast.thisdayinai.com/",
    img: "https://img.transistor.fm/4SaX-xGItZ1-nfEMIf2ly3zemXB-9j2-x93WIMySm1E/rs:fill:0:0:1/w:1400/h:1400/q:60/mb:500000/aHR0cHM6Ly9pbWct/dXBsb2FkLXByb2R1/Y3Rpb24udHJhbnNp/c3Rvci5mbS9zaG93/LzM4NjMxLzE2ODQz/OTA2ODQtYXJ0d29y/ay5qcGc.jpg",
  },
  {
    title: "The AI Daily Brief (Formerly The AI Breakdown)",
    href: "https://www.youtube.com/@AIDailyBrief",
    img: "https://d3t3ozftmdmh3i.cloudfront.net/staging/podcast_uploaded_nologo/41472609/41472609-1752234663609-8665756a468e5.jpg",
  },
  {
    title: "Super Data Science: ML & AI Podcast with Jon Krohn",
    href: "https://www.superdatascience.com/podcast",
    img: "https://megaphone.imgix.net/podcasts/efa92454-1c31-11ef-9e30-03596b470c27/image/c3e0edc239c962f8bcd144000fafa5aa.jpeg?ixlib=rails-4.3.1&max-w=3000&max-h=3000&fit=crop&auto=format,compress",
  },
  {
    title: "Last Week in AI",
    href: "https://lastweekin.ai/",
    img: "https://pbcdn1.podbean.com/imglogo/image-logo/7703921/last_week_in_ai9d471.png",
  },
  {
    title: "Latent Space: The AI Engineer Podcast",
    href: "https://www.latent.space/",
    img: "https://assets.flightcast.com/static/avzmhab7j1qi5a4r00otnyzc.jpg",
  },
  {
    title: "Practical AI",
    href: "https://changelog.com/practicalai",
    img: "https://img.transistor.fm/fLYZ7tiQO3NfSn3CXicr0vvN9mcdcj5jnytpcHtPBRM/rs:fill:0:0:1/w:1400/h:1400/q:60/mb:500000/aHR0cHM6Ly9pbWct/dXBsb2FkLXByb2R1/Y3Rpb24udHJhbnNp/c3Rvci5mbS8wOWU1/OWUyMDA4ZTdlM2Ix/ZWVjYzc1Mzc5ZTMy/NDJjMy5wbmc.jpg",
  },
  {
    title: "The AI in Business Podcast",
    href: "https://emerj.com/artificial-intelligence-podcast/",
    img: "https://static.libsyn.com/p/assets/1/c/0/2/1c02772256d769adbafc7308ab683e82/The_AI_in_business_new_Blue_32x.jpeg",
  },
  {
    title: "a16z Podcast",
    href: "https://a16z.com/a16z-podcast/",
    img: "https://image.simplecastcdn.com/images/38c671cb-f233-4f8b-884e-e3c7bd47db16/6deeb595-a193-49cd-935a-29e8ba5d9784/3000x3000/the-future-podcast-fa.jpg?aid=rss_feed",
  },
  {
    title: "NVIDIA AI Podcast",
    href: "https://blogs.nvidia.com/ai-podcast/",
    img: "https://megaphone.imgix.net/podcasts/b569e226-f45b-11ef-8eab-87014600b959/image/930a52dc0716b826d78f94be0e1a163c.png?ixlib=rails-4.3.1&max-w=3000&max-h=3000&fit=crop&auto=format,compress",
  },
  {
    title: "AI Applied: Covering AI News, Interviews and Tools - ChatGPT...",
    href: "https://www.youtube.com/@AI-Applied-Podcast",
    img: "https://d3t3ozftmdmh3i.cloudfront.net/staging/podcast_uploaded_nologo/36523960/36523960-1708787107965-844aa9e35b8f9.jpg",
  },
  {
    title: "AI For Humans: Making Artificial Intelligence Fun & Practical",
    href: "https://www.aiforhumans.show/",
    img: "https://static.libsyn.com/p/assets/0/0/d/e/00de377b76cd9f7b27a2322813b393ee/Spotify_Cover.png",
  },
  {
    title: "Everyday AI Podcast – An AI and ChatGPT Podcast",
    href: "https://www.everydayaipodcast.com/",
    img: "https://storage.buzzsprout.com/etb1r36wdmr2bglfbxx12zu48ori?.jpg",
  },
  {
    title: "AI Today Podcast",
    href: "https://open.spotify.com/show/5YBCaByUPeJMHi2hZ0DFRY",
    img: "https://storage.buzzsprout.com/p9wdc4mrd2tb35ttdvn9rz9flu97?.jpg",
  },
  {
    title: "The Artificial Intelligence Show",
    href: "https://youtube.com/playlist?list=PLgiKeuGbfWKY_xpvHQcId-lsni75G06fv&si=U10oPsWF4wTCXWJD",
    img: "https://megaphone.imgix.net/podcasts/f3be0486-55b2-11eb-b6be-cb052f0b6beb/image/TheArtificialIntelligenceShow.png?ixlib=rails-4.3.1&max-w=3000&max-h=3000&fit=crop&auto=format,compress",
  },
  {
    title: "AI Hustle: Make Money from AI and ChatGPT...",
    href: "https://www.youtube.com/@AIHustleAudio",
    img: "https://d3t3ozftmdmh3i.cloudfront.net/staging/podcast_uploaded_nologo/36539350/36539350-1698076869572-9c9b59ef0e4d.jpg",
  },
  {
    title: "A Beginner's Guide to AI",
    href: "https://beginnersguideto.ai/",
    img: "https://d3t3ozftmdmh3i.cloudfront.net/staging/podcast_uploaded_nologo/38511878/38511878-1755500199831-701765c054c77.jpg",
  },
  {
    title: "The TED AI Show",
    href: "https://www.ted.com/podcasts/the-ted-ai-show",
    img: "https://assets.pippa.io/shows/6758564a102e6d4448d19589/show-cover.png",
  },
  {
    title: "No Priors: Artificial Intelligence | Technology | Startups",
    href: "https://www.youtube.com/@NoPriorsPodcast",
    img: "https://megaphone.imgix.net/podcasts/803e0244-9d0f-11ed-923a-4bb54bf77468/image/NO_PRIORS_ALBUM_and_PROFILE_PIC-01.jpg?ixlib=rails-4.3.1&max-w=3000&max-h=3000&fit=crop&auto=format,compress",
  },
  {
    title: "Big Technology Podcast",
    href: "https://www.bigtechnology.com/",
    img: "https://megaphone.imgix.net/podcasts/e70f9594-937b-11ec-bfe0-2b4c46de3cc3/image/fbf3ffa68aee3c5ed1671862484d31a1.png?ixlib=rails-4.3.1&max-w=3000&max-h=3000&fit=crop&auto=format,compress",
  },
  {
    title: "Dwarkesh Podcast",
    href: "https://www.dwarkeshpatel.com/",
    img: "https://substackcdn.com/feed/podcast/69345/272ca2fe8578ba10ed7f8d377f3e42b9.jpg",
  },
  {
    title: "The Next Wave - AI and The Future of Technology",
    href: "https://www.youtube.com/@TheNextWavePod",
    img: "https://megaphone.imgix.net/podcasts/04296de4-ec67-11ee-b480-27740290e1c3/image/f138478d76ce9b265fa6f2ebd38b2592.png?ixlib=rails-4.3.1&max-w=3000&max-h=3000&fit=crop&auto=format,compress",
  },
  {
    title: "Training Data",
    href: "https://www.theverge.com/podcasts",
    img: "https://megaphone.imgix.net/podcasts/8ca8a61c-08b4-11ef-97ab-9fe273d59030/image/4a16fd33b06708003827556209cd42b7.png?ixlib=rails-4.3.1&max-w=3000&max-h=3000&fit=crop&auto=format,compress",
  },
  {
    title: "Lightcone Podcast",
    href: "https://youtube.com/playlist?list=PLQ-uHSnFig5Ob4XXhgSK26Smb4oRhzFmK&si=k0Pew3psAKp0kc0i",
    img: "https://d3t3ozftmdmh3i.cloudfront.net/staging/podcast_uploaded_nologo/41096716/41096716-1714669077120-3df9a565ae144.jpg",
  },
  {
    title: "The TWIML AI Podcast (formerly This Week in Machine Learning...)",
    href: "https://www.youtube.com/c/twimlai",
    img: "https://megaphone.imgix.net/podcasts/35230150-ee98-11eb-ad1a-b38cbabcd053/image/TWIML_AI_Podcast_Official_Cover_Art_1400px.png?ixlib=rails-4.3.1&max-w=3000&max-h=3000&fit=crop&auto=format,compress",
  },
  {
    title: "BG2Pod with Brad Gerstner and Bill Gurley",
    href: "https://www.bg2pod.com/",
    img: "https://d3t3ozftmdmh3i.cloudfront.net/staging/podcast_uploaded_nologo/40236188/40236188-1706073929930-da002b9be1355.jpg",
  },
  {
    title: "Me, Myself, and AI",
    href: "https://sloanreview.mit.edu/audio-series/me-myself-and-ai/",
    img: "https://megaphone.imgix.net/podcasts/f17e8dc0-0c38-11ec-bf53-9f4a62c5ca79/image/e29161dbd538d42efb795abab6d2a92c.jpg?ixlib=rails-4.3.1&max-w=3000&max-h=3000&fit=crop&auto=format,compress",
  },
  {
    title: "Data Skeptic",
    href: "https://dataskeptic.com/",
    img: "https://static.libsyn.com/p/assets/0/e/4/b/0e4bd71bb64c6e45/DS_-_New_Logo_assets_-_JL_DS_Logo_Stacked_-_Color_2.jpg",
  },
  {
    title: "Machine Learning Street Talk (MLST)",
    href: "https://www.youtube.com/c/machinelearningstreettalk",
    img: "https://d3t3ozftmdmh3i.cloudfront.net/staging/podcast_uploaded_nologo/4981699/4981699-1699437574146-72eb9fca1ae9c.jpg",
  },
  {
    title: "AI Explored",
    href: "https://www.youtube.com/@AIExaminer",
    img: "https://content.production.cdn.art19.com/images/02/53/34/1d/0253341d-b4b9-4928-92a0-6301d6d77f42/a33da065aa9d09fa652d61d798c05e6adf715eedab208cd0290ea932ecaaa1b7d3fe0faffdcd31f56f49984fd877ca5e5db96aaf0f541ec5338fe51c68cb0878.jpeg",
  },
  {
    title: "Decoder with Nilay Patel",
    href: "https://www.theverge.com/decoder-podcast-with-nilay-patel",
    img: "https://megaphone.imgix.net/podcasts/5c6a4f4a-e69c-11e8-8066-17a10182e4c8/image/The_Verge_Decoder_Tileart_3000.jpg?ixlib=rails-4.3.1&max-w=3000&max-h=3000&fit=crop&auto=format,compress",
  },
  {
    title: "Artificial Intelligence Masterclass",
    href: "https://podcasts.apple.com/us/podcast/artificial-intelligence-masterclass/id1721855892",
    img: "https://megaphone.imgix.net/podcasts/a9f30ad2-9c49-11ee-9c7d-9f6f358aee99/image/4e96033113cd7227e70e52f4bca79435.jpg?ixlib=rails-4.3.1&max-w=3000&max-h=3000&fit=crop&auto=format,compress",
  },
  {
    title: "The Logan Bartlett Show",
    href: "https://www.youtube.com/@theloganbartlettshow",
    img: "https://assets.flightcast.com/static/mvghz0zdwyrk2szd0g6hi08z.jpg",
  },
  {
    title: "Lenny's Podcast: Product | Career | Growth",
    href: "https://www.lennyspodcast.com/",
    img: "https://substackcdn.com/feed/podcast/10845/6f98962f26f1b886bac3a845bb7ee00b.jpg",
  },
  {
    title: "AI and I",
    href: "https://aiandipodcast.com/",
    img: "https://d3t3ozftmdmh3i.cloudfront.net/staging/podcast_uploaded_nologo/39682537/39682537-1716981968134-80d30ad1c83.jpg",
  },
  {
    title: `"The Cognitive Revolution" | AI Builders, Researchers...`,
    href: "https://www.cognitiverevolution.ai/",
    img: "https://megaphone.imgix.net/podcasts/30f818da-c930-11ed-9b4b-1352ca96fb17/image/the-cognitive-revolution-branded-1.jpg?ixlib=rails-4.3.1&max-w=3000&max-h=3000&fit=crop&auto=format,compress",
  },
  {
    title: "Google DeepMind: The Podcast",
    href: "https://deepmind.google/discover/the-podcast/",
    img: "https://image.simplecastcdn.com/images/69d76c2c-4017-4f2f-8838-a33d03d55657/efed23b2-7898-47ae-a8a9-027226017a2d/3000x3000/podcast-20platform-20cover.jpg?aid=rss_feed",
  },
  {
    title: "DataFramed",
    href: "https://www.datacamp.com/podcast",
    img: "https://artwork.captivate.fm/4700b4b7-f386-4200-9a46-640458f2dcbd/5cfec01b44f3e29fae1fb88ade93fc4aecd05b192fbfbc2c2f1daa412b7c192.jpg",
  },
  {
    title: "The Changelog: Software Development, Open Source",
    href: "https://changelog.com/podcast",
    img: "https://cdn.changelog.com/static/images/podcasts/podcast-original-f16d0363067166f241d080ee2e2d4a28.png",
  },
  {
    title: "Social Media Marketing Podcast",
    href: "https://www.socialmediaexaminer.com/shows/",
    img: "https://content.production.cdn.art19.com/images/8c/bd/d5/09/8cbdd509-12fe-469b-8adc-45bc71756822/74766bc3648f57f59ec689c56181671a825448ec8105a6e5122b350f496c2a0dab9565d79ce6b94e684c305b22a415c48a69ac94e8104e11c55649469a51bc0d.jpeg",
  },
  {
    title: "The Kevin Rose Show",
    href: "https://kevinrose.com/",
    img: "https://substackcdn.com/feed/podcast/2776405/fbb7584e7d92ba0a4b06090967ed7dc1.jpg",
  },
  {
    title: "Eye On A.I.",
    href: "https://www.youtube.com/channel/UC-o9u9QL4zXzBwjvT1gmzNg",
    img: "https://static.libsyn.com/p/assets/0/2/1/3/0213c7d9616b570b16c3140a3186d450/LOGO_1400x1400.jpg",
  },
  {
    title: "Data Engineering Podcast",
    href: "https://www.dataengineeringpodcast.com/",
    img: "https://assets.podhome.fm/f6ff0caa-931b-4c08-bfdd-08dc7f5cd336/638557928872209534cover.jpg",
  },
  {
    title: "Possible",
    href: "https://youtube.com/playlist?list=PLV6sFuGk6xd8VmLNy0SAEnY3MRQ0AGZx2&si=ujOlkvq2aUW-D96t",
    img: "https://megaphone.imgix.net/podcasts/e49026c8-c28a-11ed-b2f3-038ea4339b78/image/Possible_Key_Art_3000x3000.jpg?ixlib=rails-4.3.1&max-w=3000&max-h=3000&fit=crop&auto=format,compress",
  },
  {
    title: "Hard Fork",
    href: "https://www.nytimes.com/column/hard-fork",
    img: "https://image.simplecastcdn.com/images/4105a47a-42e5-4ccc-887a-832af7989986/23965394-f5e4-4fdb-b150-639f4910353e/3000x3000/nyt-hf-album-art-3000-2.jpg?aid=rss_feed",
  },
];

// --- CARD ---
function PodcastCard({ item }: { item: PodcastItem }) {
  return (
    <Card
      elevation={1}
      sx={{
        borderRadius: 2,
        overflow: "hidden",
        transition: "transform 200ms ease, box-shadow 200ms ease",
        "&:hover": { transform: "translateY(-4px)", boxShadow: 6 },
      }}
    >
      <CardActionArea
        component={MUILink}
        href={item.href}
        target="_blank"
        rel="noopener"
        sx={{ display: "block" }}
      >
        <Box
          sx={{
            position: "relative",
            width: "100%",
            pt: "100%",
            bgcolor: "grey.100",
          }}
        >
          <Box
            component="img"
            src={item.img}
            alt={item.alt || `${item.title} Cover Art`}
            loading="lazy"
            sx={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </Box>

        <CardContent sx={{ p: 1.5 }}>
          <Typography
            variant="body2"
            fontWeight={600}
            color="text.primary"
            sx={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              minHeight: 40,
              "&:hover": { color: "#1B2E85" },
            }}
          >
            {item.title}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

// --- SECTION ---
export function AIPodcastsSection({
  title = "AI Podcasts",
  items = AI_PODCASTS,
  bgColor = "#F5F5F5",
}: {
  title?: string;
  items?: PodcastItem[];
  bgColor?: string;
}) {
  const [showAll, setShowAll] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  // Determine current column count: xs=2, sm=2, md=3, lg=4 (cap at 4)
  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("lg"));
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));

  const columns = isLgUp ? 4 : isMdUp ? 3 : isSmUp ? 2 : 2; // max 4 per row
  const visible = showAll ? items : items.slice(0, columns);

  return (
    <Box ref={sectionRef} sx={{ bgcolor: bgColor, py: { xs: 6, md: 8 } }}>
      <Box sx={{ maxWidth: "1200px", mx: "auto", px: { xs: 2, sm: 3, md: 4 } }}>
        {/* Header */}
        <Box sx={{ maxWidth: 800, mx: "auto", textAlign: "center", mb: 4 }}>
          <Typography
            variant="h3"
            fontWeight="bold"
            color="#1B2E85"
            sx={{ mb: 1 }}
          >
            {title}
          </Typography>
          <Divider
            sx={{
              width: 60,
              height: 4,
              backgroundColor: "#1B2E85",
              mx: "auto",
            }}
          />
        </Box>

        {/* One-row (collapsed) or full (expanded) */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "repeat(2, 1fr)",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
              lg: "repeat(4, 1fr)",
            },
            gap: { xs: 1.5, sm: 2, md: 2.5 },
          }}
        >
          {visible.map((item, idx) => (
            <PodcastCard key={idx} item={item} />
          ))}
        </Box>

        {/* Load All / Show Less */}
        {items.length > columns && (
          <Box sx={{ textAlign: "center", mt: 4 }}>
            <Button
              variant="contained"
              onClick={() => {
                if (showAll) {
                  // collapsing → jump to top instantly (no animation)
                  sectionRef.current?.scrollIntoView({
                    behavior: "auto",
                    block: "start",
                  });
                }
                setShowAll((s) => !s);
              }}
              sx={{
                backgroundColor: "#1B2E85",
                fontWeight: "bold",
                px: 3,
                "&:hover": { backgroundColor: "#16246d" },
              }}
            >
              {showAll ? "Show less" : `Load all (${items.length})`}
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
}
